import AutocompleteInput from './AutocompleteInput.view';

export default AutocompleteInput;